import { ExpandMore, ChevronRight } from "@mui/icons-material";
import { TreeItem, TreeView } from "@mui/lab";
import { FormControlLabel, Checkbox } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { userActions } from "../../redux/actions/user.actions";
import { UserFacilitiesTree } from "../../redux/models/userFacilities";
import { selectedPortRegions } from "../../redux/selectors/user.selector";
import { useState } from "react";


interface PortfoliosProps{
  portfolioList:UserFacilitiesTree|undefined;
  selectedPortfolios:any[];
  setSelectedPortfolios:(portfolios: any[]) => void;
  isOpen:never[];
  setIsOpen:(isOpen:any[])=>void;
  fromPage:string;
}

const Portfolios=({portfolioList,selectedPortfolios,fromPage,setSelectedPortfolios,isOpen,setIsOpen}:PortfoliosProps)=> {
  const dispatch = useDispatch();
  const selectedPortRegion = useSelector(selectedPortRegions);
  const [treeClass,setTreeClass]=useState<string>(fromPage=='home'?'portfolio-menu add-btn home-tree':'portfolio-menu add-btn report-tree');

  const handleNodeToggle = (event:any, nodeIds: any) => {
    setIsOpen(nodeIds);
    sessionStorage.setItem("nodeIds",nodeIds);
  };

  const getFacilityCount=(nodes:any)=>{
    if(nodes.facilityId==0){
      const filteredArray = selectedPortfolios.filter((element) => !selectedPortRegion.includes(element));
      return ' ('+filteredArray.length+')';
    }
    else{
      return nodes.children?.length>1?' ('+nodes.children?.length+')':'';
    }
    
  }

  const getAllChild=(nodes: UserFacilitiesTree | null,array: any[])=> {
    if (nodes === null) return [];
    array.push(nodes.facilityId);
    if (Array.isArray(nodes.children)) {
      nodes.children.forEach(node => {
        array = [...array, ...getAllChild(node,array)];
        array = array.filter((v, i) => array.indexOf(v) === i);
      });
    }
    return array;
  }

  const handleCollapse=(e:any)=>{
    if(e.target.id=='0'){
      setTreeClass('portfolio-menu add-btn');
      setIsOpen([]);
    }
  }

  const getNodeById=(nodes: UserFacilitiesTree, id: number) =>{
    if (nodes.facilityId === id) {
      return nodes;
    } else if (Array.isArray(nodes.children)) {
      let result = null;
      nodes.children.forEach(node => {
        if (!!getNodeById(node, id)) {
          result = getNodeById(node, id);
        }
      });
      return result;
    }

    return null;
  }

  function getChildById(node: UserFacilitiesTree, id: number) {
    let array: number[] = [];
    return getAllChild(getNodeById(node, id),array);
  }

  function getOnChange(checked: boolean, nodes: UserFacilitiesTree) {
    if(portfolioList){
      const allNode: number[] = getChildById(portfolioList, nodes.facilityId);
      let array = checked
        ? [...selectedPortfolios, ...allNode]
        : selectedPortfolios.filter(value => !allNode.includes(value));
      console.log(array)
      array = array.filter((v, i) => array.indexOf(v) === i);
  
      setSelectedPortfolios(array);
      localStorage.setItem("selectedFacilities",JSON.stringify(array));
    dispatch(userActions.setSelectedFacilities(array));
      
    }
    
  }

  const UserFacilitiesTree = (nodes: UserFacilitiesTree) => (

    <TreeItem
      key={nodes.facilityId?.toString()+nodes.facilityName}
      nodeId={nodes.facilityId?.toString()}
      onChange={(e:any)=>console.log(e.target.parentElment)}
      collapseIcon={<svg id={nodes.facilityId+""} onClick={(e:any)=>handleCollapse(e)} className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium css-i4bv87-MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true" data-testid="ExpandMoreIcon"><path d="M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"></path></svg>}
      label={
        <FormControlLabel
          control={
            <Checkbox
              checked={selectedPortfolios?.some(item => item === nodes.facilityId)}
              onChange={(event:any) =>
                getOnChange(event.currentTarget.checked, nodes)
              }
              onClick={(e:any) => e.stopPropagation()}
              size="small"
            />
          }
          label={<>{nodes.facilityName+getFacilityCount(nodes)}</>}
          key={nodes.facilityId?.toString()}
        />
      }
    >
      {Array.isArray(nodes.children)
        ? nodes.children.map(node => UserFacilitiesTree(node))
        : null}
    </TreeItem>
  );

  return (
    <div className={isOpen.length>0?treeClass:'portfolio-menu add-btn'}>
    {portfolioList&&<TreeView
      expanded={isOpen}
      onNodeToggle={handleNodeToggle}
      defaultCollapseIcon={<ExpandMore />}
      defaultExpanded={[]}
      defaultExpandIcon={<ChevronRight />}
    >
      {UserFacilitiesTree(portfolioList)}
    </TreeView>}
    </div>
  );
}
export default Portfolios